import { gql } from "graphql-tag";

export const getProductCatalogueV2 = (pageType, isNewSliceType = false) => {
  const typeprefix = `${pageType}${isNewSliceType ? "Slices" : "Body"}`;

  return gql`
    fragment ${pageType}_product_catalogue_v2 on ${typeprefix}Product_catalogue_v2 {
      type
      variation {
        variation: __typename
        ... on ${typeprefix}Product_catalogue_v2Default {
          primary @skip(if: $lazy) {
            title
            max_products_limit
            list_type
          }
          items @include(if: $lazy) {
            product
          }
        }
        ... on ${typeprefix}Product_catalogue_v2Searchspring {
          primary @skip(if: $lazy) {
            title
            max_products_limit
            list_type
            tag
            skip_params
          }
        }
        ... on ${typeprefix}Product_catalogue_v2Searchspring_bundle {
          primary @skip(if: $lazy) {
            title
            offer_title
            offer_sub_title
            max_products_limit
            list_type
            skip_params
            discount
            qualifying_tags
            pdp_callout
          }
        }
        ... on ${typeprefix}Product_catalogue_v2Variant {
          primary @skip(if: $lazy) {
            title
            max_products_limit
            list_type
          }
          items @include(if: $lazy) {
            variant
          }
        }
      }
    }`;
};
